import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_CALAMITY_SERVICE_BASE,
  async loadPackages() {
    await authentication.isAuthenticated();
    return axios
      .get(this.baseUrl + "/GetMap", {
        headers: { Authorization: "Bearer " + authentication.getToken() }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadClients() {
    await authentication.isAuthenticated();
    return axios
      .get(process.env.VUE_APP_API_CLIENT_SERVICE_BASE + "/GetClients", {
        headers: { Authorization: "Bearer " + authentication.getToken() }
      })
      .then(response => {
        return response.data;
      });
  }
};
